export default __webpack_public_path__ + "static/media/c5032178-d765-4f39-a4f6-65e0085b494d.05b3fb41.woff";